import PropTypes from "prop-types";
import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Label,
  Form,
  FormGroup,
  Input,
} from "reactstrap";
import icon1 from "../../assets/images/logo1.png";
// I removed iconlogo since it isn't used

const TermsConditionsPage = () => {
    document.title = "Terms & Conditions | Funnl";
    const currentDate = new Date();
  return (
    <div className="homepage-bg min-vh-100 d-flex flex-column">
      <Container>
        <div className="d-flex align-items-center home-top-icon-pos">
          <img src={icon1} alt="logo" className="me-2" />
          <span className="fw-medium fs-4 home-page-color">Funnl</span>
        </div>
        <div className="mt-5">
          <p>Effective Date: 07/08/2024</p>
          <p>
            Thank you for applying with Ancile services. This Privacy Policy
            outlines how we collect, use, disclose, and manage your information.
          </p>

          <h5>1. Information We Collect</h5>
          <p>We collect the following types of information when you register for Job Application:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, address, email
              address, phone number, date of birth, and any other information
              you provide during registration.
            </li>
            <li>
              <strong>Transactional Information:</strong> Details related to
              transactions conducted using our services.
            </li>
            <li>
              <strong>Device and Usage Information:</strong> Information about
              your device and how you use our services, including IP address,
              browser type, and operating system.
            </li>
          </ul>

          <h5>2. How We Use Your Information</h5>
          <ul>
            <li>To setup your application as Delivery driver</li>
            <li>To communicate with you about your application and provide support.</li>
            <li>To comply with legal obligations and enforce our policies.</li>
          </ul>

          <h5>3. Sharing of Information</h5>
          <ul>
            <li>With service providers who assist us in providing services.</li>
            <li>With law enforcement or regulatory authorities in response to legal requests.</li>
            <li>In connection with a merger, acquisition, or sale of all or a portion of our assets.</li>
          </ul>

          <h5>4. Your Choices</h5>
          <p>You can choose not to provide certain information, although this may limit your ability to Apply to the Job.</p>

          <h5>5. Security</h5>
          <p>We implement appropriate technical and organizational measures to protect your information from unauthorized access and disclosure.</p>

          <h5>6. Children’s Privacy</h5>
          <p>Ancile services are not intended for people under the age of 18. We do not knowingly collect personal information.</p>

          <h5>7. Changes to This Privacy Policy</h5>
          <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the updated policy on our website.</p>

          <h5>8. Contact Us</h5>
          <p>
            If you have any questions or concerns about this Privacy Policy or
            our practices, please contact us at{" "}
            <a href="mailto:support@ancile.services">support@ancile.services</a>.
          </p>
        </div>
      </Container>

      {/* Footer */}
      <footer className="text-center py-3 small text-secondary fs-6 mt-auto">
        ©{currentDate?.getFullYear()} Powered by{" "}
        <a href="https://ancile.services" className="text-primary text-decoration-none" target="_blank" rel="noopener noreferrer">
          Ancile Services
        </a>{" "}
        |{" "}
        <a href="/privacy-policy" className="text-primary text-decoration-none">
          Privacy Policy
        </a>
      </footer>
    </div>
  );
};

export default TermsConditionsPage;
